import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'password-strength',
	templateUrl: './password-strength.component.html',
	styleUrls: ['./password-strength.component.css']
})
export class PasswordStrengthComponent implements OnInit, OnChanges {
	@Input() password: string;
	@Input() stringStyle: boolean = false;
	@Output() strengthStatus = new EventEmitter<number>();

	strength: number = 0;

	readonly strengthColorMap: string[] = [
		'',
		'#D10000',
		'#00A300',
	];

	constructor() { }

	ngOnInit(): void {
	}

	ngOnChanges() {
		this.strength = this.checkStrength(this.password);
		this.strengthStatus.emit(this.strength);
	}

	/**
	 * Check password strength against the password policy
	 * 	strength = 0 --> no password is typed yet, nothing is shown
	 * 	strength = 1 --> Weak, at least one of the policy rules is not met
	 * 	strength = 2 --> Strong, all of the policy rules are met
	 * 		(12 characters at least, a lower case, an upper case, a digit and a special character)
	 * @param text
	 */
	checkStrength(text: string) {
		if(!text)
			return 0;
		const isStrong =	text.length >= 12 &&
							/[a-z]/.test(text) &&			// Lower case
							/[A-Z]/.test(text) &&			// Upper case
							/[0-9]/.test(text) &&			// Digit
							/[^A-Za-z0-9]/.test(text);		// Special character
		return isStrong ? 2 : 1;
	}
}
